import { useState } from 'react'
import { Container } from './style'

export default function AccordionRoot({children}) {
    return (
        <Container>
            {children}
        </Container>
    )
}